//import 'vuetify/dist/vuetify.min.css'
import '@mdi/font/css/materialdesignicons.css'
import './stylus/main.styl'

import Vue from 'vue'
import Vuetify from 'vuetify'
import VueResource from 'vue-resource'
import VueClipboard from 'vue-clipboard2'
import App from './App.vue'
import router from './router'
import store from './store'

import GoogleIcon from '@/components/elements/icons/Google.vue'

Vue.config.productionTip = false

Vue.use(VueResource)
Vue.use(VueClipboard)
Vue.use(Vuetify, {
	icons: {
		'gcolorized': {
			component: GoogleIcon
		}
	}
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app-target')
